module.exports = __webpack_public_path__ + "static/media/homepage-header.19edc3a2.png";